import { render, staticRenderFns } from "./yz_wechatShareImg.vue?vue&type=template&id=03e56c8c&scoped=true"
import script from "./yz_wechatShareImg.vue?vue&type=script&lang=js"
export * from "./yz_wechatShareImg.vue?vue&type=script&lang=js"
import style0 from "./yz_wechatShareImg.vue?vue&type=style&index=0&id=03e56c8c&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e56c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e56c8c')) {
      api.createRecord('03e56c8c', component.options)
    } else {
      api.reload('03e56c8c', component.options)
    }
    module.hot.accept("./yz_wechatShareImg.vue?vue&type=template&id=03e56c8c&scoped=true", function () {
      api.rerender('03e56c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui_components/yz_wechatShareImg.vue"
export default component.exports